import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Tag, Tooltip } from '@enechain/ecloud-designsystem'

import { MemberStatus } from '~/gen/proto/bff/v1/model_pb'
import { dict } from '~/pages/Members/dict'

const STATUS_BACKGROUND_COLOR = {
  [MemberStatus.UNKNOWN]: 'Surface.neutralMid',
  [MemberStatus.INVITED]: 'Surface.neutralMid',
  [MemberStatus.ACTIVE]: 'Surface.positiveMid',
  [MemberStatus.DELETED]: 'Surface.neutralMid',
  [MemberStatus.SUSPENDED]: 'Surface.warningMid',
} satisfies Record<MemberStatus, string>

const STATUS_DESCRIPTION_KEY: Partial<Record<MemberStatus, string>> = {
  [MemberStatus.SUSPENDED]: 'pages.members.statusDescription.suspended',
}

type Props = {
  status: MemberStatus
}
export const MemberStatusTag: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation()
  const descriptionKey = STATUS_DESCRIPTION_KEY[status]

  const tag = (
    <Tag
      color="Text.highEmphasis"
      backgroundColor={STATUS_BACKGROUND_COLOR[status]}
    >
      {dict.status(status)}
    </Tag>
  )

  if (descriptionKey == null) {
    return tag
  }

  return <Tooltip label={t(descriptionKey)}>{tag}</Tooltip>
}
